import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/board/re_btn.png'
import _imports_1 from '@/assets/board/excel_ico.png'


const _withScopeId = n => (_pushScopeId("data-v-35ad980b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "layer" }
const _hoisted_2 = { class: "wrap" }
const _hoisted_3 = { class: "content_layer" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { id: "board_layer" }
const _hoisted_6 = { class: "board_search_v1 board_search_wrap" }
const _hoisted_7 = { class: "sch_box" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "0" }, "이름", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "1" }, "팀", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "2" }, "직책", -1))
const _hoisted_11 = [
  _hoisted_8,
  _hoisted_9,
  _hoisted_10
]
const _hoisted_12 = {
  key: 0,
  class: "sch_input_box"
}
const _hoisted_13 = {
  key: 1,
  class: "sch_input_box"
}
const _hoisted_14 = ["value"]
const _hoisted_15 = ["value"]
const _hoisted_16 = { class: "sch_btns" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_18 = { class: "board_top" }
const _hoisted_19 = { class: "board_top_btns" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "엑셀다운로드", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = { class: "" }
const _hoisted_24 = { class: "board_list" }
const _hoisted_25 = { class: "board_table" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { width: "4%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "4%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "10%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "10%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "10%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "10%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "14%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "14%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "12%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "6%" }),
  /*#__PURE__*/_createElementVNode("col", { width: "6%" })
], -1))
const _hoisted_27 = { class: "chk" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "순번", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "아이디", -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "이름", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "팀", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "직책", -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "등록일시", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "최종로그인", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "구분", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "승인여부", -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "X 계정", -1))
const _hoisted_39 = { key: 0 }
const _hoisted_40 = { class: "chk" }
const _hoisted_41 = ["onUpdate:modelValue", "onInput"]
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, null, -1))
const _hoisted_43 = { class: "board_btns" }
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["onClick"]
const _hoisted_46 = ["src"]
const _hoisted_47 = ["src"]
const _hoisted_48 = { key: 1 }
const _hoisted_49 = { colspan: "10" }
const _hoisted_50 = { key: 2 }
const _hoisted_51 = { colspan: "10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_NoResult = _resolveComponent("NoResult")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_PageBtn = _resolveComponent("PageBtn")!
  const _component_UserModal = _resolveComponent("UserModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Header),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_7, [
                    _withDirectives(_createElementVNode("select", {
                      name: "",
                      id: "",
                      class: "select",
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.filter.searchType) = $event))
                    }, _hoisted_11, 512), [
                      [
                        _vModelSelect,
                        $setup.filter.searchType,
                        void 0,
                        { number: true }
                      ]
                    ]),
                    ($setup.filter.searchType == 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            placeholder: "검색어를 입력하세요.",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.filter.keyword) = $event)),
                            onKeydown: _cache[2] || (_cache[2] = _withKeys(
//@ts-ignore
(...args) => ($setup.getUserList && $setup.getUserList(...args)), ["enter"]))
                          }, null, 544), [
                            [_vModelText, $setup.filter.keyword]
                          ])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          _withDirectives(_createElementVNode("select", {
                            class: "filter_select",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.filter.selectItem) = $event))
                          }, [
                            ($setup.filter.searchType == 1)
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList($setup.state.deptList, (item) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    value: item.idx
                                  }, _toDisplayString(item.name), 9, _hoisted_14))
                                }), 256))
                              : _createCommentVNode("", true),
                            ($setup.filter.searchType == 2)
                              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList($setup.state.positionList, (item) => {
                                  return (_openBlock(), _createElementBlock("option", {
                                    value: item.idx
                                  }, _toDisplayString(item.name), 9, _hoisted_15))
                                }), 256))
                              : _createCommentVNode("", true)
                          ], 512), [
                            [_vModelSelect, $setup.filter.selectItem]
                          ])
                        ])),
                    _createElementVNode("div", _hoisted_16, [
                      _createElementVNode("button", {
                        type: "button",
                        class: "sch_btn",
                        onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.getUserList && $setup.getUserList(...args)))
                      }, "검색하기"),
                      _createElementVNode("button", {
                        type: "button",
                        class: "sch_re_btn",
                        onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.resetSearch && $setup.resetSearch(...args)))
                      }, [
                        _hoisted_17,
                        _createTextVNode(" 초기화 ")
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "board_btn board_ico_btn",
                    onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.excelDownLoad && $setup.excelDownLoad(...args)))
                  }, _hoisted_22)
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "board_btn",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.openmodal(1)))
                  }, "추가")
                ])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("table", _hoisted_25, [
                  _hoisted_26,
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, [
                        _createElementVNode("label", _hoisted_27, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.state.checkList[0]) = $event)),
                            onInput: _cache[9] || (_cache[9] = ($event: any) => ($setup.checkedList(0)))
                          }, null, 544), [
                            [_vModelCheckbox, $setup.state.checkList[0]]
                          ]),
                          _hoisted_28
                        ])
                      ]),
                      _hoisted_29,
                      _hoisted_30,
                      _hoisted_31,
                      _hoisted_32,
                      _hoisted_33,
                      _hoisted_34,
                      _hoisted_35,
                      _hoisted_36,
                      _hoisted_37,
                      _hoisted_38
                    ])
                  ]),
                  (!$setup.state.isLoading)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_39, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.user.list, (item, idx) => {
                          return (_openBlock(), _createElementBlock("tr", null, [
                            _createElementVNode("td", null, [
                              _createElementVNode("label", _hoisted_40, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  "onUpdate:modelValue": ($event: any) => (($setup.state.checkList[idx + 1]) = $event),
                                  onInput: ($event: any) => ($setup.checkedList(idx + 1))
                                }, null, 40, _hoisted_41), [
                                  [_vModelCheckbox, $setup.state.checkList[idx + 1]]
                                ]),
                                _hoisted_42
                              ])
                            ]),
                            _createElementVNode("td", null, _toDisplayString($setup.state.currentPage === 1
                                                    ? $setup.numberFormat(idx + 1)
                                                    : $setup.numberFormat($setup.state.perPage * ($setup.state.currentPage - 1) + idx + 1)), 1),
                            _createElementVNode("td", null, _toDisplayString(item.id), 1),
                            _createElementVNode("td", null, _toDisplayString(item.name), 1),
                            _createElementVNode("td", null, _toDisplayString(item.deptVO?.name), 1),
                            _createElementVNode("td", null, _toDisplayString(item.positionVO?.name), 1),
                            _createElementVNode("td", null, _toDisplayString($setup.formatDate(item.createDate)), 1),
                            _createElementVNode("td", null, _toDisplayString(item.loginDate ? $setup.formatDate(item.loginDate) : ""), 1),
                            _createElementVNode("td", null, [
                              _createElementVNode("div", _hoisted_43, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "blue_btn",
                                  onClick: ($event: any) => ($setup.openmodal(2, item.idx))
                                }, "상세", 8, _hoisted_44),
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "gray_btn",
                                  onClick: ($event: any) => ($setup.deleteUser(idx))
                                }, "삭제", 8, _hoisted_45)
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("span", null, [
                                _createElementVNode("img", {
                                  src: 
                                                        item.state === 1
                                                            ? require('@/assets/board/approve.png')
                                                            : require('@/assets/board/no_approve.png')
                                                    ,
                                  alt: ""
                                }, null, 8, _hoisted_46)
                              ])
                            ]),
                            _createElementVNode("td", null, [
                              _createElementVNode("span", null, [
                                _createElementVNode("img", {
                                  src: 
                                                        item.twitterId !== null && item.twitterId !== ''
                                                            ? require('@/assets/board/approve.png')
                                                            : require('@/assets/board/no_approve.png')
                                                    ,
                                  alt: ""
                                }, null, 8, _hoisted_47)
                              ])
                            ])
                          ]))
                        }), 256))
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.user.list.length === 0 && !$setup.state.isLoading)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_48, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_49, [
                            _createVNode(_component_NoResult)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  ($setup.state.isLoading)
                    ? (_openBlock(), _createElementBlock("tbody", _hoisted_50, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("td", _hoisted_51, [
                            _createVNode(_component_Spinner)
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              ($setup.user.list.length !== 0 && !$setup.state.isLoading)
                ? (_openBlock(), _createBlock(_component_PageBtn, {
                    key: 0,
                    currentPage: $setup.state.currentPage,
                    totalLength: $setup.state.totalLength,
                    perPage: $setup.state.perPage,
                    onOnPaging: $setup.handlePageChange
                  }, null, 8, ["currentPage", "totalLength", "perPage", "onOnPaging"]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_UserModal, {
      userInfo: $setup.user.info,
      show: $setup.modal.isUserModal,
      onClose: $setup.modalClose,
      btnTitle: $setup.modal.btnTitle
    }, null, 8, ["userInfo", "show", "onClose", "btnTitle"])
  ], 64))
}